import { render, staticRenderFns } from "./visa.vue?vue&type=template&id=3b590abe&"
import script from "./visa.vue?vue&type=script&lang=js&"
export * from "./visa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports